/*
 * Copyright (c) Funtip GbR 2018.
 * Simon Oldeboershuis, Perry Prust
 */

import { faHome } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Nav, Navbar, NavbarBrand, NavItem, NavLink } from 'reactstrap';
import { playlistAdminPath } from '..';
import { Login } from '../../Login';
import { ErrorMessage } from '../../System/ErrorMessage';
import { Spinner } from '../../System/Spinner';
import { playlistSearchPath } from '../PlaylistSearch';

interface MenuPlaylistProps {}

const MenuPlaylist: React.FC<MenuPlaylistProps> = props => {
    return (
        <>
            <Navbar color="light">
                <NavbarBrand>
                    Playlist-Admin&nbsp;
                    <small>
                        <Link to="/">
                            <FontAwesomeIcon icon={faHome} size="sm"/>
                        </Link>
                    </small>
                </NavbarBrand>
                <Nav>
                    <NavItem>
                        <NavLink tag={Link} to={playlistAdminPath + "/reports"}>
                            Auswertungen
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={Link} to={playlistAdminPath + "/statistics"}>
                            Statistik
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={Link} to={playlistSearchPath()}>
                            Playlist
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={Link} to={playlistAdminPath + "/song"}>
                            Songs
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={Link} to={playlistAdminPath + "/album"}>
                            Alben
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink tag={Link} to={playlistAdminPath + "/maintenance"}>
                            Aktionen
                        </NavLink>
                    </NavItem>
                    <Login />
                    <ErrorMessage />
                </Nav>
            </Navbar>
            <Spinner />
        </>
    );
};

export default MenuPlaylist;
